// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"6fd0d893","40":"cd02e648","340":"543dcd5f","404":"d9fe6fe5","432":"81be63db","702":"86b91ea1","816":"dd47eb57","923":"68c1a3b6"}[chunkId] + ".chunk.js";
};